import React from 'react';

export default function NotFound() {
  const NotFoundStyle = {
  paddingTop: "100px",
  textAlign: "center",
  };
  return (
    <div style={NotFoundStyle}>
      <h3>Sorry, page not found!</h3>
    </div>
  );
}
